import { FaMapMarkerAlt } from "react-icons/fa";

export default function MapMarker (props) {
    return (
        <div className="map-marker" onClick={props.onClick}>
            <FaMapMarkerAlt />
        </div>
    )
}